window.openResetPassword = function(){
    $('#forgot_password_modal').find('.btn-danger, .alert-success').hide();
    $('#loginModal').modal('hide');
    $('#forgot_password_modal').modal('show');
}

window.submitResetPassword = function(){
    let formData = $('#forgot_password_modal_form').serialize();

    $('#forgot_password_modal').find('.btn-danger, .alert-success').hide();

    axios.post(routes.ClientAdminResetPassword, formData)
    .then(function(response){        
        $('#forgot_password_modal').find('.alert-success').show();
    }).catch(function(errors){
        if(errors.response.status === 429){
            $('#forgot_password_modal').find('.btn-danger').show();
        } else{
            console.error(errors);    
        }
    }); 
}

window.backFromResetPassword = function(){
    $('#forgot_password_modal').modal('hide');
    $('#loginModal').modal('show');
}